import CounterControl from 'components/InputNumberOfPeople/CounterControl';
import React from 'react';
import Label from '~/reusable-components/inputs/Label';

const CSS = require('./PeopleInput.module.scss');

interface PeopleInputProps {
  label: string;
  maxPeople?: number;
  defaultValues: {
    adults: number;
    children: number;
  };
}

function PeopleInput({
  label,
  maxPeople = 50,
  defaultValues,
}: PeopleInputProps) {
  const [numberOfPeople, setNumberOfPeople] = React.useState({
    adults: defaultValues.adults,
    children: defaultValues.children,
  });

  const onAdultsIncrease = () => {
    const newValue = numberOfPeople.adults + 1;
    if (newValue + numberOfPeople.children <= maxPeople) {
      setNumberOfPeople({ ...numberOfPeople, adults: newValue });
    }
  };
  const onAdultsDecrease = () => {
    const newValue = numberOfPeople.adults - 1;
    if (newValue > 0) {
      setNumberOfPeople({ ...numberOfPeople, adults: newValue });
    }
  };

  const onChildrenIncrease = () => {
    const newValue = numberOfPeople.children + 1;
    if (newValue + numberOfPeople.adults <= maxPeople) {
      setNumberOfPeople({ ...numberOfPeople, children: newValue });
    }
  };

  const onChildrenDecrease = () => {
    const newValue = numberOfPeople.children - 1;
    if (newValue >= 0) {
      setNumberOfPeople({ ...numberOfPeople, children: newValue });
    }
  };

  return (
    <>
      <Label>{label}</Label>
      <div className={CSS.PeopleInputContainer}>
        <CounterControl
          value={numberOfPeople.adults}
          minValue={1}
          maxValue={maxPeople - numberOfPeople.children}
          onIncrease={onAdultsIncrease}
          onDecrease={onAdultsDecrease}
        >
          Adults
        </CounterControl>
        <CounterControl
          value={numberOfPeople.children}
          minValue={0}
          maxValue={maxPeople - numberOfPeople.adults}
          onIncrease={onChildrenIncrease}
          onDecrease={onChildrenDecrease}
        >
          Children
        </CounterControl>
        <input hidden name="adults" value={numberOfPeople.adults} />
        <input hidden name="children" value={numberOfPeople.children} />
      </div>
    </>
  );
}

export default PeopleInput;
